import React from "react";
import { Bar } from "react-chartjs-2";

const MonoBar = props => (
	<Bar
		data={props.data}
		// width={400}
		// height={100}
		responsive
		plugins={[
			{
				beforeUpdate: function(chart) {
					chart.data.labels.forEach(function(e, i, a) {
						if (e && e.split) {
							let aiValues = e.split(" ");
							//console.log(aiValues);
							for (let j = 0; j < aiValues.length; j++) {
								let aiValue = aiValues[j];
								if (typeof aiValue === "string") {
									aiValue = aiValue.replace("@", " ");
									aiValues[j] = aiValue;
								}
							}
							a[i] = aiValues;
						}
					});
				},
			},
		]}
		options={{
			plugins: {
				datalabels: false,
			},
			animation: {
				duration: 3000, // general animation time
			},
			maintainAspectRatio: false,
			scales: {
				xAxes: [
					{
						gridLines: {
							offsetGridLines: false,
							display: false,
						},
						scaleLabel: {
							fontSize: 5,
							fontColor: "#2e22aa",
						},
						ticks: {
							autoSkip: false,
							maxRotation: 0,
							minRotation: 0,
							fontSize: 9,
							callback: function(value, index, values) {
								return value;
							},
						},
					},
				],
				yAxes: [
					{
						scaleLabel: {
							display: true,
						},
						ticks: {
							scaleBeginAtZero: true,
						},
					},
				],
			},
		}}
		legend={{ display: false }}
	/>
);

export default MonoBar;



// WEBPACK FOOTER //
// src/modules/stats/components/GraphViews/MonoBar.js